import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { HStack, Heading, Spinner, Text, VStack } from "native-base";
import Modal from "../modal";
import colors from "../../constants/colors";
import { allowExit, preventExit } from "../../utils";

function PendingPaymentModal(props) {
  const { isOpen, onRequestClose } = props;

  useEffect(() => {
    if (isOpen) {
      preventExit();
    }
    return () => {
      allowExit();
    };
  }, [isOpen]);

  return (
    <Modal maxWidth={700} isOpen={isOpen}>
      <VStack padding={5} space={3}>
        <Spinner size="lg" color={colors.primary} />
        <Heading color={colors.primary} textAlign="center">
          Estamos validando tu pago
        </Heading>
        <Text textAlign="center">
          Una vez que se confirme tu pago, procederemos con tu solicitud y
          recibirás un correo electrónico de confirmación en breve.
        </Text>
        <Text textAlign="center">
          Si deseas salir, simplemente haz clic en el botón de abajo.
        </Text>
        <button onClick={onRequestClose}>
          <HStack
            backgroundColor={colors.primary}
            paddingY={2}
            paddingX={5}
            borderRadius="full"
            justifyContent="center">
            <Text color={colors.white} textAlign="center">
              Continuar
            </Text>
          </HStack>
        </button>
      </VStack>
    </Modal>
  );
}

PendingPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
};

export default React.memo(PendingPaymentModal);
